import React, { useState } from "react";
import { Box, Checkbox, FormControlLabel, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Defina aqui o link do contrato quando a página/arquivo estiver disponível
const CONTRATO_URL = "";

const fieldSx = {
    "& .MuiOutlinedInput-root": {
        backgroundColor: "white",
        borderRadius: "10px",
        "&.Mui-focused fieldset": {
            borderColor: "#0b243d",
        },
    },
    "& .MuiInputLabel-root.Mui-focused": {
        color: "#0b243d",
    },
};

const checkboxSx = {
    color: "#0b243d",
    "&.Mui-checked": {
        color: "#0b243d",
    },
};

const linkStyle = { color: "#0b243d", fontWeight: 600, textDecoration: "underline" };

const StepThree = ({ senha, setSenha, confirmarSenha, setConfirmarSenha, agreeTerms, setAgreeTerms, agreeContract, setAgreeContract, agreePrivacyPolicy, setAgreePrivacyPolicy }) => {
    const [showSenha, setShowSenha] = useState(false);
    const [showConfirmarSenha, setShowConfirmarSenha] = useState(false);

    const senhasDiferentes = confirmarSenha.length > 0 && senha !== confirmarSenha;

    const visibilityAdornment = (show, setShow) => (
        <InputAdornment position="end">
            <IconButton
                onClick={() => setShow((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
                size="small"
                aria-label={show ? "Ocultar senha" : "Mostrar senha"}
            >
                {show ? <VisibilityOff sx={{ fontSize: 20 }} /> : <Visibility sx={{ fontSize: 20 }} />}
            </IconButton>
        </InputAdornment>
    );

    return (
        <Box sx={{ width: "100%" }}>
            <Typography sx={{ mt: 0, mb: "20px", fontSize: { xs: "0.9rem", md: "0.95rem" }, color: "#555" }}>
                Crie uma senha para acessar a plataforma Clarea Vital.
            </Typography>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                    gap: "20px",
                }}
            >
                <TextField
                    label="Senha"
                    required
                    type={showSenha ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    fullWidth
                    autoComplete="new-password"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    sx={fieldSx}
                    slotProps={{
                        input: { endAdornment: visibilityAdornment(showSenha, setShowSenha) },
                    }}
                />
                <TextField
                    label="Confirmar Senha"
                    required
                    type={showConfirmarSenha ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    fullWidth
                    autoComplete="new-password"
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    error={senhasDiferentes}
                    helperText={senhasDiferentes ? "As senhas não coincidem" : ""}
                    sx={fieldSx}
                    slotProps={{
                        input: { endAdornment: visibilityAdornment(showConfirmarSenha, setShowConfirmarSenha) },
                    }}
                />
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "4px", mt: "20px" }}>
                <FormControlLabel
                    sx={{ alignItems: "flex-start", m: 0 }}
                    control={
                        <Checkbox
                            checked={agreeTerms}
                            onChange={(e) => setAgreeTerms(e.target.checked)}
                            size="small"
                            sx={{ ...checkboxSx, pt: "2px" }}
                        />
                    }
                    label={
                        <Typography variant="body2" sx={{ color: "#333" }}>
                            Li e concordo com os{" "}
                            <a href="/termos-de-uso" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                                Termos de Uso
                            </a>{" "}
                            e a{" "}
                            <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                                Política de Privacidade
                            </a>.
                        </Typography>
                    }
                />
                <FormControlLabel
                    sx={{ alignItems: "flex-start", m: 0 }}
                    control={
                        <Checkbox
                            checked={agreeContract}
                            onChange={(e) => setAgreeContract(e.target.checked)}
                            size="small"
                            sx={{ ...checkboxSx, pt: "2px" }}
                        />
                    }
                    label={
                        <Typography variant="body2" sx={{ color: "#333" }}>
                            Li e concordo com os termos do{" "}
                            <a href="/contrato-de-prestacao-de-servicos" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                                Contrato de Prestação de Serviços
                            </a>.
                        </Typography>
                    }
                />
            </Box>
        </Box>
    )
}

export default StepThree;
